module.exports = __webpack_public_path__ + "static/media/13A.4b46914c.png";